import type { RouteObject } from "react-router-dom";
import Layout from "../components/layout/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import Investments from "../pages/investments/page";
import NewsGrid from "../pages/news/page";
import NewsDetail from "../pages/news-detail/page";
import BlogsGrid from "../pages/blogs/page";
import BlogsDetail from "../pages/blogs-detail/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                index: true,
                element: <Home />,
            },
            {
                path: "services",
                element: <Services />,
            },
            {
                path: "investments",
                element: <Investments />,
            },
            {
                path: "news",
                element: <NewsGrid />,
            },
            {
                path: "news/:slug",
                element: <NewsDetail />,
            },
            {
                path: "blogs",
                element: <BlogsGrid />,
            },
            {
                path: "blogs/:slug",
                element: <BlogsDetail />,
            },
            {
                path: "about",
                element: <About />,
            },
            {
                path: "contact",
                element: <Contact />,
            },
            {
                path: "*",
                element: <NotFound />,
            },
        ],
    },
];

export default routes;
